/** 开锁人身份（与小程序 device/lock/enums/UserType 一致） */
const UserType = Object.freeze({
  LANDLORD: 1,
  TENANT: 2,
  ADMIN: 3,
  Tourist: 4,

  getText(type) {
    const n = Number(type);
    const map = {
      1: '房东',
      2: '租客',
      3: '管理员',
      4: '游客',
    };
    return map[n] || '未知';
  },
});

export default UserType;
